<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <!-- Background overlay -->
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
        @click="handleCancel"
      ></div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

      <!-- Modal panel -->
      <div
        class="relative inline-block align-bottom bg-white dark:bg-gray-800 rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
      >
        <div class="sm:flex sm:items-start">
          <!-- Warning icon -->
          <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 dark:bg-red-800 sm:mx-0 sm:h-10 sm:w-10">
            <ExclamationTriangleIcon class="h-6 w-6 text-red-600 dark:text-gray-100" aria-hidden="true" />
          </div>

          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <!-- Title -->
            <h3 class="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100" id="modal-title">
              {{ data.title || 'Confirm Action' }}
            </h3>

            <!-- Message -->
            <div class="mt-2">
              <p class="text-sm text-gray-500 dark:text-gray-300">
                {{ data.message }}
              </p>
            </div>

            <!-- Additional details if provided -->
            <div v-if="data.details" class="mt-3 p-3 bg-gray-50 dark:bg-gray-500 rounded-md">
              <p class="text-xs text-gray-600 dark:text-gray-100">
                {{ data.details }}
              </p>
            </div>
          </div>
        </div>

        <!-- Action buttons -->
        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <button
            type="button"
            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm transition-colors"
            @click="handleConfirm"
            :disabled="loading"
          >
            {{ loading ? 'Processing...' : (data.confirmText || 'Confirm') }}
          </button>
          <button
            type="button"
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 dark:border-gray-500 hover:dark:border-gray-700 shadow-sm px-4 py-2 bg-white dark:bg-gray-500 text-base font-medium text-gray-700 dark:text-gray-100 hover:bg-gray-50 hover:dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:w-auto sm:text-sm transition-colors"
            @click="handleCancel"
            :disabled="loading"
          >
            {{ data.cancelText || 'Cancel' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'
import {useConfirmStore} from '@/stores/confirm.ts';

const confirmStore = useConfirmStore();

const isOpen = computed(() => confirmStore.isOpen);
const data = computed(() => confirmStore.data);
const loading = computed(() => confirmStore.loading);

function handleConfirm() {
  if (!confirmStore.loading) {
    confirmStore.confirmAction()
  }
}

function handleCancel() {
  if (!confirmStore.loading) {
    confirmStore.cancelAction()
  }
}
</script>
